<template>
  <v-container text-xs-center fluid>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h2 class="text-center">GoDial Cloud Call Recording</h2>
        <p class="text-center">
          Get Insights into every call with GoDial Cloud Call Recording.
        </p>
        <v-card class="pa-4" style="border-radius: 10px;">
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/_ypOdJj_Dm4"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-card>
      </v-col>
    </v-row>

    <v-container class="mt-10">
      <v-row justify="center">
        <v-col cols="12">
          <h2 class="text-center font-weight-bold">
            Why Choose GoDial Cloud Call Recording?
          </h2>
          <p class="text-center">
            Record all calls made from the GoDial App and get complete insights
            into every conversation.
          </p>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-6">
        <!-- Effortless Recording -->
        <v-col cols="12" md="4">
          <v-row>
            <v-col cols="8">
              <h4 class="font-weight-bold">Effortless Recording</h4>
              <p>
                No need for complex setups or integrations—just use your phone’s
                SIM card and enjoy seamless recording without relying on
                additional devices or services.
              </p>
            </v-col>
            <v-col cols="4" class="text-right">
              <h1 class="display-1 font-weight-bold">1</h1>
            </v-col>
          </v-row>
        </v-col>

        <!-- No KYC Hassle -->
        <v-col cols="12" md="4">
          <v-row>
            <v-col cols="8">
              <h4 class="font-weight-bold">No KYC Hassle</h4>
              <p>
                Skip time-consuming KYC procedures and start making calls
                directly from your SIM card. No need for number registrations.
              </p>
            </v-col>
            <v-col cols="4" class="text-right">
              <h1 class="display-1 font-weight-bold">2</h1>
            </v-col>
          </v-row>
        </v-col>

        <!-- All-in-One Solution -->
        <v-col cols="12" md="4">
          <v-row>
            <v-col cols="8">
              <h4 class="font-weight-bold">All-in-One Solution</h4>
              <p>
                Get everything you need in one place. An all-in-one solution for
                call center CRM, call recording, and autodialing, which means
                fewer headaches and a smoother user experience.
              </p>
            </v-col>
            <v-col cols="4" class="text-right">
              <h1 class="display-1 font-weight-bold" style="font-size: 200px;">
                3
              </h1>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-timeline>
      <v-timeline-item
        v-for="step in steps"
        :key="step.id"
        :right-align="step.id % 2 === 0"
        color="green"
      >
        <template v-slot:opposite>
          <strong>Step {{ step.id }}</strong>
          <v-img :src="step.image" style="max-height: 300px;" contain></v-img>
        </template>
        <v-card outlined class="pa-3 pt-10">
          <v-row>
            <v-col cols="12" md="12">
              <h4>{{ step.title }}</h4>
              <p>{{ step.description }}</p>
            </v-col>
            <!-- <v-col cols="12" md="6">
              <v-img contain height="100" :src="noCall" />
            </v-col> -->
          </v-row>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      steps: [
        {
          id: 1,
          title: "Login to the Dashboard",
          description:
            "Visit app.godial.cc, go to the Recording tab, and click on Cloud Call Recording and enable it.",
          image: require("../assets/cloudrecording/1.png"),
        },
        {
          id: 2,
          title: "Enter Contact Numbers",
          description:
            "Go to the Team and Members tab and verify that users' phone numbers are entered. If missing, add them to ensure proper functionality.",
          image: require("../assets/cloudrecording/2.png"),
        },
        {
          id: 3,
          title: "Set the Dialer on the Enterprise App",
          description:
            "Log in to the GoDial Enterprise App. Go to the Settings tab and select Phone Dialer with Call Recording under the Default Dialer. Click 'Set.'",
          image: require("../assets/cloudrecording/3.png"),
        },
        {
          id: 4,
          title: "Place a Call",
          description:
            "Open a contact list or manually enter a number and make a call. The first call connects to the Recording Number.",
          image: require("../assets/cloudrecording/4.png"),
        },
        {
          id: 5,
          title: "Merge Calls",
          description:
            "Once the first call is connected, a pop-up will prompt you to place the second call. Click it and merge the calls. The receiver will only see your contact number.",
          image: require("../assets/cloudrecording/5.png"),
        },
        {
          id: 6,
          title: "Dispose and Save",
          description:
            "Once the call ends, dispose of it by saving the details. On clicking next, the recording file will be instantly synced.",
          image: require("../assets/cloudrecording/6.png"),
        },
        {
          id: 7,
          title: "Listen to Recordings",
          description:
            "Visit the Master Report on the web dashboard to check, listen to, or download the call recordings.",
          image: require("../assets/cloudrecording/7.jpeg"),
        },
      ],
      selectedOption: "mobile", // Default selected option
      recordCallsWithTrueCaller: false,
      enableRecording: false,
      panel: [],
      addStorage: 0,
      loading: false,
      recordsPerPage: [1, 5, 15, 30, 60],

      page: 1,
      pageCount: 0,
      totalRecords: 0,
      records: 15,

      files: [],
      fileTableHeaders: [
        {
          text: "File Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Size", value: "size", sortable: false },
        { text: "Time", value: "createdOn", sortable: false },
        { text: "", value: "downlaod", sortable: false },
        { text: "", value: "delete", sortable: false },
      ],
    };
  },
  created() {
    this.fetchFiles();
    this.recordCallsWithTrueCaller = this.$store.state.companyDetails.recordCallsWithTrueCaller;
  },
  computed: {
    ...mapGetters(["ENDPOINT", "teams", "selectedTeam", "companyDetails"]),
    noCall() {
      return require("../assets/nocall.png");
    },
  },
  methods: {
    learnMore(option) {
      if (option === "mobile") {
        this.$router.push("/mobile-recording");
      } else if (option === "cloud") {
        this.$router.push("/cloud-recording");
      }
    },
    openYouTube(url) {
      window.open(url, "_blank");
    },
    selectOption(option) {
      this.selectedOption = option;
      console.log(`${option} Call Recording Selected`);
    },
    removeRecording(item) {
      console.log("item 123", item);

      this.$http
        .delete(`${this.ENDPOINT}/attachments/${item}`)
        .then((response) => {
          this.loader = false;
          this.fetchFiles();
          this.$swal({ type: "success", text: "Successfully deleted" });
          // this.close();
        })
        .catch((err) => {
          this.loader = false;
          this.$swal({ type: "error", text: "Something went wrong" });
        });
    },
    download(src, dialingOpt) {
      if (src != "") {
        if (dialingOpt == "exotel") {
          console.log(src);
          var a = document.createElement("a");

          a.href = src;
          a.setAttribute("download", src.toString());
          a.target = "_blank";
          a.click();
        } else {
          console.log(src);
          var au = document.createElement("a");

          au.href = `${this.$store.state.ENDPOINT}/storages/get/${src}?access_token=${this.$store.getters.user.token}`;
          au.setAttribute("download", src.toString());
          au.target = "_blank";
          au.click();
        }
      }
    },
    mathfloorCustom(value) {
      if (value == 0) {
        return "0MB";
      }

      var filterValueInBytes = value * 1024 * 1024;

      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      var i = parseInt(
        Math.floor(Math.log(filterValueInBytes) / Math.log(1024))
      );

      var finalValueData =
        Math.round(filterValueInBytes / Math.pow(1024, i), 2) + "" + sizes[i];

      return finalValueData;
    },
    nextSet() {
      this.page++;
      this.pagination();
    },
    prevSet() {
      this.page--;
      this.pagination();
    },
    async pagination() {
      try {
        this.pageCount = Math.ceil(this.totalRecords / this.records);
        if (this.page > this.pageCount) {
          this.page = 1; //set default
        }
        this.files = await this.fetchFiles(
          this.records,
          this.records * this.page - this.records
        );

        // Save default pagination of seperate pages
        this.paginate[
          this.$router.currentRoute.name
            .toString()
            .trim()
            .replace(/ /g, "")
            .toLowerCase()
        ] = {
          page: this.page,
          pageCount: this.pageCount,
          records: this.records,
          totalRecords: this.totalRecords,
        };
        this.$store.commit("setPagination", this.paginate);

        return;
      } catch (e) {
        this.loader = false;
      }
    },

    async fetchFiles(limit, skip) {
      if (typeof limit == "undefined" && typeof skip == "undefined") {
        try {
          var where = {
            companyId: this.$store.getters.user.companyId,
          };
          var response = await this.$http.get(
            this.$store.getters.ENDPOINT +
              "/attachments/count?where=" +
              encodeURIComponent(JSON.stringify(where))
          );

          this.totalRecords = response.body.count;
        } catch (e) {
          console.log(e);
        }
      }
      this.loading = true;

      this.files = [];
      if (limit == undefined || limit == undefined) {
        limit = 5;
        skip = 0;
      }
      var filter = {
        skip: skip,
        limit: limit,
        order: "createdOn DESC",
        where: {
          companyId: this.$store.getters.user.companyId,
          type: "exotelRecording",
          typeOfFile: "attachment",
        },
      };

      var res = await this.$http.get(
        this.$store.getters.ENDPOINT +
          "/attachments?filter=" +
          encodeURIComponent(JSON.stringify(filter))
      );

      this.files = _.map(res.body, (c) => {
        c.size = this.mathfloorCustom(c.size);
        c.createdOn = moment(c.createdOn).format("lll");
        return c;
      });

      this.loading = false;
      return this.files;
    },

    upgradeStorage() {},
    updateRecordCalls() {
      var self = this;

      self.$http
        .patch(
          `${this.$store.getters.ENDPOINT}/companies/${self.$store.getters.user.companyId}`,
          { recordCallsWithTrueCaller: self.recordCallsWithTrueCaller }
        )
        .then((response) => {
          self.$store.dispatch("getCompanyDetails", {
            companyId: self.$store.getters.user.companyId,
          });
          console.log("response", response.body);
        })
        .catch((err) => {
          self.$swal({
            type: "error",
            text: "Something went wrong. Couldn't Update",
          });
        });
    },
  },
};
</script>

<style scoped>
/* .v-timeline-item {
  border-left: 2px solid #4caf50;
} */
.v-card {
  box-shadow: none;
  background-color: #f9f9f9;
}
.step-number {
  font-size: 2.5rem;
  color: #4caf50;
  margin-bottom: 10px;
}

h2 {
  font-weight: bold;
  margin-bottom: 20px;
}
p {
  font-size: 16px;
  color: #555;
}
.v-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  min-height: 200px;
  border-radius: 10px !important;
}
.v-card:hover {
  background-color: #f5f5f5;
  transform: translateY(-5px);
}
.selectable-card {
  cursor: pointer;
  transition: 0.3s ease;
}
.selectable-card:hover {
  background-color: #f5f5f5;
  transform: scale(1.02);
}

.active-card {
  background-color: #d6d6d6; /* Grey background for selected card */
  border: 2px solid #4caf50;
}

.customMarginBottom {
  margin-bottom: 6px !important;
}

@media (min-width: 1200px) {
  .recordPadding {
    padding-left: 30%;
    padding-right: 30%;
  }
}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {
  .recordPadding {
    padding-left: 30%;
    padding-right: 30%;
  }
}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 991px) {
  .recordPadding {
    padding-left: 20%;
    padding-right: 20%;
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .recordPadding {
    padding-left: 1%;
    padding-right: 1%;
  }
}

/* Portrait phones and smaller */
@media (max-width: 480px) {
  .recordPadding {
    padding-left: 1%;
    padding-right: 1%;
  }
}
</style>
